import { Stack } from "@mui/material";
import MaterialSelect from "../../components/MaterialSelect";
import MaterialTypography from "../../components/MaterialTypography";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import DynamicTable from "../../components/Dynamictabel/Dynamictabel";
import { useEffect, useState } from "react";
import MaterialInput from "../../components/MaterialInput";
import axios from "axios";
import { BASE_URL, fetchData, postData } from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext";
import SimpleTable from "../../components/SimpleTable";
import { width } from "@mui/system";

const TaskFilter = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useAuth();
  const [types, setTypes] = useState(false);
  const [project, setProject] = useState([]);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [filterData, setFilterData] = useState({
    resources: { value: null, label: "All" },
    name: { value: null, label: "All" },
    startDate: "",
    endDate: "",
  });

  const userColumns = [
    { header: "PROJECT NAME", key: "project_name" },
    { header: "TASK NAME", key: "task_title" },
    { header: "TASK CODE", key: "task_code" },
    // { header: "TEAM NAME", key: "teams" },
    { header: "MILESTONE", key: "milestone_name" },
    // { header: "START DATE", key: "start_date" },
    // { header: "END DATE", key: "end_date" },
    // { header: "ALLOCATED HOURS", key: "allocated_hours" },
    // { header: "ACTUAL HOURS", key: "actual_hours" },
    { header: "STATUS", key: "status" },
    { header: "ACTION", key: "action" },
  ];
  useEffect(() => {
    const today = new Date();

    // Get the current day of the week (0 = Sunday, 6 = Saturday)
    const currentDay = today.getDay();

    // Clone today's date to avoid mutating it
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - currentDay); // Previous Sunday

    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() + (6 - currentDay)); // Upcoming Saturday

    const formatDate = (date) => date.toISOString().split("T")[0];

    setFilterData({
      startDate: formatDate(startOfWeek),
      endDate: formatDate(endOfWeek),
    });
  }, []);

  useEffect(() => {
    fetchTeamMembers();
    fetchProjectData();
  }, []);

  useEffect(() => {
    if (filterData?.startDate && filterData?.endDate) {
      getTaskList();
    }
  }, [types, filterData]);

  const fetchTeamMembers = async () => {
    setIsLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        value: item.id,
        label: `${item.employee_name} -${item.team?.team_name}`,
      }));
      setTeamMembersData([
        {
          value: null,
          label: "All",
        },
        ...transformedData,
      ]);
    } catch (error) {
      console.error("Error fetching team members:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchProjectData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("user_id", currentUser?.id);
    try {
      const res = await fetchData("/api/project/");
      if (res?.status) {
        setProject([
          {
            project_name: "All",
            id: null,
          },
          ...res?.data,
        ]);
      } else {
        setProject([]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const getTaskList = async () => {
    setIsLoading(true);
    if (!types) {
      try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(
          `${BASE_URL}api/taskfilter/`,
          {
            project_id: filterData?.name?.value,
            employee_id: filterData?.resources?.value,
            start_date: filterData?.startDate,
            end_date: filterData?.endDate,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response?.data?.data;
        setData(data);
      } catch (error) {
        console.error(error, "error");
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        const response = await postData("api/unassignedEmployeesView/", {
          start_date: filterData?.startDate,
          end_date: filterData?.endDate,
        });

        setData(response?.unassigned_employees);
      } catch (error) {
        console.error(error, "error");
      } finally {
        setIsLoading(false);
      }
    }
  };
  // handle onchange function
  const handleChange = (event, selectEvent) => {
    let meetingDatas = { ...filterData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "name") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          meetingDatas[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          meetingDatas[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "resources") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          meetingDatas[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          meetingDatas[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      meetingDatas[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "endDate":
          {
            if (event.target.value) {
              meetingDatas[event.target.name + "Status"] = "success";
            } else {
              meetingDatas[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "startDate":
          {
            if (event.target.value) {
              meetingDatas[event.target.name + "Status"] = "success";
            } else {
              meetingDatas[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      meetingDatas[event.target.name] = event.target.value;
    }

    setFilterData(meetingDatas);
  };
  // Table column data
  const userColumnsNew = [
    { header: "S.No", key: "id" },
    { header: "Emplyoee Name", key: "emplyoee" },
    { header: "Designation", key: "designation" },
  ];
  // Table row data
  const userData = data.map((item, ind) => ({
    id: ind + 1,
    emplyoee: item?.name,
    designation: item?.designation,
  }));

  return (
    <DashboardLayout>
      <div
        style={{
          display: "flex",
          width: "90%",
          justifyContent: "space-between",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={9}
        >
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h5" fontWeight="bold" color="dark">
              Task Filter
            </MaterialTypography>
            <MaterialTypography variant="caption" color="text">
              You can view the portfolio here.
            </MaterialTypography>
          </Stack>
        </Stack>


        {/* <div style={{ display: "flex", justifyContent: "flex-end", gap: 4 }}>
          <Stack>
            <MaterialTypography variant="caption" color="text">
              Total Hours
            </MaterialTypography> <MaterialInput
              disabled
              value="24hrs" />
          </Stack>
          
          <Stack>
            <MaterialTypography variant="caption" color="text">
              Actual Hours
            </MaterialTypography>
            <MaterialInput
              disabled
              value="24hrs" />
          </Stack>
        </div> */}
{/* 
          <div style={{ display: "flex", justifyContent:"flex-end",gap:10}}>
  <MaterialTypography variant="caption" color="text" >
    Total Hours:
  </MaterialTypography>
  <MaterialInput disabled value="24hrs"  />

  <MaterialTypography variant="caption" color="text" >
    Actual Hours:
  </MaterialTypography>
  <MaterialInput disabled value="24hrs" />
</div> */}


        {/* <Stack>
          <button
            style={{
              padding: "10px",
              border: "none",
              backgroundColor: "green",
              borderRadius: "5px",
              color: "white",
              width: "100px",
            }}
            onClick={() => setTypes(!types)}
          >
            {types ? "Tasked" : "UnTasked"}
          </button>
        </Stack> */}
      </div>
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        {!types && (
          <>
            <div>
              <MaterialTypography variant="caption" color="text">
                Resources Name
              </MaterialTypography>
              <MaterialSelect
                name="resources"
                value={filterData?.resources}
                customStyles={{ optionPadding: 10 }}
                onChange={handleChange}
                options={teamMembersData || []}

              />
            </div>
            <div>
              <MaterialTypography variant="caption" color="text">
                Project Name
              </MaterialTypography>
              <MaterialSelect
                name="name"
                value={filterData?.name}
                onChange={handleChange}
                customStyles={{ optionPadding: 20 }}
                options={project?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.project_name,
                  };
                })}
              />
            </div>
          </>
        )}
        <div>
          <MaterialTypography variant="caption" color="text">
            Start Date
          </MaterialTypography>
          <MaterialInput
            name="startDate"
            type="date"
            value={filterData?.startDate}
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div>
          <MaterialTypography variant="caption" color="text">
            End Date
          </MaterialTypography>
          <MaterialInput
            type="date"
            name="endDate"
            value={filterData?.endDate}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
      {!types ? (
        <DynamicTable
          columns={userColumns}
          data={data}
          actionVisibility={{
            showEdit: false,
            showView: false,
            showDelete: false,
          }}
          isLoading={isLoading}
          edit={false}
          deleteAction={false}
          view={false}
          multipleaction={false}
        />
      ) : (
        <SimpleTable
          columns={userColumnsNew}
          data={userData}
          deleteAction={false}
          isLoading={isLoading}
          view={false}
          edit={false}
          download={false}
        />
      )}
    </DashboardLayout>
  );
};

export default TaskFilter;
